// extracted by mini-css-extract-plugin
export default {"header":"HeaderPage_header__+SEs0"};